<template>
  <div v-if="hasSlides" id="carouselIndicators" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item" v-for="(slide, index) in slides" :class="{active: index == 0}" :key="index">
        <img :src="slide" class="d-block w-100" />
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselIndicators" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselIndicators" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</template>

<script>
export default {
  name:  "Carrousel",
  props:    {
    slides: []
  },
  computed: {
    hasSlides: function() {
      return this.slides.filter(image => image != '/banners/original/missing.png').length > 0;
    }
  }
}
</script>
